<template>
    <div class="wapper">

        <el-page-header @back="goBack" content="发票详情" class="header">
        </el-page-header>
        <div class="content-wapper">
            <div class="opertion-wapper">
                <el-button size="small" v-if="info.state == 1" type="primary" @click="submitDialog">确认提交</el-button>
            </div>
            <span class="title">申请基础信息</span>
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>申请编号</label>
                        <span>{{ info.invoiceApplyCode }}</span>
                    </div>
                    <div>
                        <label>开票状态</label>
                        <span>{{ info.stateName }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>开票数量</label>
                        <span>{{ info.countApplyInvoice }}张</span>
                    </div>
                    <div>
                        <label>申请人</label>
                        <span>{{ info.creatorName }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>所属部门</label>
                        <span>{{ info.ownerDepartmentName }}</span>
                    </div>
                    <div>
                        <label>申请时间</label>
                        <span>{{ info.gmtCreate }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label style="width:111px;">是否含特殊发票内容</label>
                        <span>{{ info.specialFlag == 1 ? '是' : '否' }}</span>
                    </div>

                </li>

            </ul>
        </div>
        <div class="content-wapper">
            <span class="title">申请订单信息</span>
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>客户名称</label>
                        <span>{{ info.customerName }}</span>
                    </div>
                    <div>
                        <label>本次开票总额</label>
                        <span>{{ info.totalApplyInvoiceExact }}元</span>
                    </div>
                </li>
            </ul>

            <el-table :data="info.reOrderList">
                <el-table-column prop="orderNo" label="订单编号">
                </el-table-column>
                <el-table-column prop="orderTypeName" label="订单类型">
                </el-table-column>
                <el-table-column prop="invoiceApplyAmountExact" label="本次开票金额">
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <span style="color:blue;cursor:pointer;" @click="detail(scope.row)">订单详情</span>
                    </template>
                </el-table-column>

            </el-table>

        </div>
        <div class="content-wapper">
            <span class="title">客户发票信息</span>
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>发票抬头</label>
                        <span>{{ info.invoiceTitleInfo.invoiceTitle }}</span>
                    </div>
                    <div>
                        <label>纳税人识别号</label>
                        <span>{{ info.invoiceTitleInfo.taxpayerCode }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>公司注册电话</label>
                        <span>{{ info.invoiceTitleInfo.companyPhone }}</span>
                    </div>
                    <div>
                        <label>公司注册地址</label>
                        <span>{{ info.invoiceTitleInfo.companyAddress }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>开户行名称</label>
                        <span>{{ info.invoiceTitleInfo.companyBankName }}</span>
                    </div>
                    <div>
                        <label>开户行账号</label>
                        <span>{{ info.invoiceTitleInfo.companyBankAccount }}</span>
                    </div>
                </li>
                <div v-for="(item) in info.invoiceList" :key="item.companyId">
                    <li>
                        <div>
                            <label>发票类型</label>
                            <span>{{ item.invoiceTypeName }}</span>
                        </div>
                        <div v-if="item.invoiceType == 3 || item.invoiceType == 4 || item.invoiceType == 5 || item.invoiceType == 6">
                            <label>接收人手机号</label>
                            <span>{{ item.receiverPhone }}</span>
                        </div>
                    </li>
                    <li v-if="item.invoiceType == 3 || item.invoiceType == 4 || item.invoiceType == 5 || item.invoiceType == 6">
                        <div>
                            <label>接收人邮箱</label>
                            <span>{{ item.receiverEmail }}</span>
                        </div>
                    </li>
                </div>

            </ul>
        </div>
        <div class="content-wapper" v-if="info.invalidInfoList" style="width:100%;">
            <span class="title">开票作废信息明细</span>
            <div>

                <el-table :data="info.invalidInfoList">
                    <el-table-column prop="invalidUserName" label="作废申请人">
                    </el-table-column>
                    <el-table-column prop="gmtCreate" label="作废申请时间">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span style="color:blue;cursor:pointer;" @click="information(scope.row)">查看审核信息</span>
                        </template>
                    </el-table-column>
                </el-table>

            </div>

        </div>
        <div class="content-wapper" style="width:100%;">
            <span class="title">开票信息</span>
            <ul class="info-wapper" style="background-color:rgb(240 240 240);padding:10px;margin-bottom:30px;"
                v-for="(item) in info.invoiceList" :key="item.companyId">
                <li>
                    <div>
                        <label>开票公司</label>
                        <span>{{ item.companyName }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>合约开票总额</label>
                        <span>{{ item.totalInvoiceExact }}元</span>
                    </div>
                    <div>
                        <label>单张开具最大额</label>
                        <span>{{ item.maxAmountEach }}元</span>
                    </div>
                </li>
                <div v-if="info.state != 5 && info.state != 6 && info.state != 7 && info.state != 8">
                    <div v-for="(ite) in item.contentBaseList" :key="ite.id" style="width:100%;">
                        <div class="table-top"> 开票信息编号： {{ ite.invoiceInfoCode }}</div>
                        <el-table :data="ite.contentList">
                            <el-table-column label="内容编号">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 }}

                                </template>

                            </el-table-column>
                            <el-table-column prop="invoiceContent" label="发票内容">
                                <template slot-scope="scope">
                                    <el-tooltip :content="scope.row.invoiceContent" placement="top-start">
                                        <p>{{ scope.row.invoiceContent }}</p>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="standard" label="规格型号">
                            </el-table-column>
                            <el-table-column prop="unit" label="单位">
                            </el-table-column>
                            <el-table-column prop="count" label="数量">
                            </el-table-column>
                            <el-table-column prop="price" label="单价">

                            </el-table-column>
                            <el-table-column prop="invoiceAmount" label="开票金额">
                            </el-table-column>
                        </el-table>
                        <table class="remarks-table" style="background-color: #ffff;">
                            <tr>
                                <td class="remarks-title">
                                    备注信息：{{ ite.remark }}
                                </td>
                            </tr>
                            <tr>
                                <td class="remarks-title">
                                    {{ ite.fileName }} <el-button v-if="ite.fileUrl" type="text"
                                        @click="down(ite.fileUrl)">下载附件</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-else>
                    <el-table :data="item.contentBaseList">
                        <el-table-column prop="invoiceInfoCode" label="开票信息编号">
                        </el-table-column>
                        <el-table-column prop="drawerName" label="开票人">
                        </el-table-column>
                        <el-table-column prop="drawerTime" label="开票时间">
                        </el-table-column>
                        <el-table-column prop="invoiceCode" label="发票号码">
                        </el-table-column>
                        <el-table-column prop="" label="操作">
                            <template slot-scope="scope">
                                <span style="color:blue;cursor:pointer;margin-left:0;"
                                    @click="informationDialog(scope.row)">修改记录</span>
                                <span style="color:blue;cursor:pointer;margin-left:10px;"
                                    @click="informationDialog2(scope.row)">内容明细</span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>

            </ul>
            <br>
        </div>
        <div class="content-wapper" style="width:100%;" v-if="info.state != 1">
            <span class="title">发票审核信息</span>
            <examine ref="examine" :businessCode="info.id" :templateId="info.templateId"></examine>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>提交后发票信息不可编辑修改，是否确认提交？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="作废审核信息" @close='closeDialog' :visible.sync="informationDialogVisible">
            <examine ref="examine" v-if="informationShow" :businessCode="informationId" :templateId="informationTemplateId">
            </examine>
        </el-dialog>

        <el-dialog title="修改记录" destroy-on-close width="70%" @close='informationDialogClose'
            :visible.sync="informationDialogShow">

            <el-table :data="getContentDetailData">
                <el-table-column label="修改记录序号">
                    <template slot-scope="scope">
                        <span> {{ (scope.$index + 1).toString().padStart(2, '0') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="invoiceCode" label="发票号码">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span>{{ scope.$index == 0 ? '开票' : '修改' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="drawerName" label="开票/修改人">
                </el-table-column>
                <el-table-column prop="gmtModified" label="开票/修改时间">
                </el-table-column>
            </el-table>
            <el-table :data="getContentDetailData">
                <el-table-column prop="invoiceInfoCode" label="开票信息编号">
                </el-table-column>
                <el-table-column prop="invoiceCode" label="发票编号">
                </el-table-column>
                <el-table-column prop="drawerName" label="开票人">
                </el-table-column>
                <el-table-column prop="gmtModified" label="开票时间">
                </el-table-column>

            </el-table>
        </el-dialog>
        <el-dialog title="发票内容明细" destroy-on-close @close='informationDialogClose2' :visible.sync="informationDialogShow2">
            <el-table :data="getCodeModifyData">
                <el-table-column label="内容编号">
                    <template slot-scope="scope">
                        <span> {{ (scope.$index + 1).toString().padStart(3, '0') }}</span>

                    </template>

                </el-table-column>
                <el-table-column prop="invoiceContent" label="发票内容">
                </el-table-column>
                <el-table-column  prop="standard" label="规格型号">
                </el-table-column>
                <el-table-column prop="unit" label="单位">
                </el-table-column>
                <el-table-column prop="count" label="数量">
                </el-table-column>
                <el-table-column prop="price" label="单价">

                </el-table-column>
                <el-table-column prop="invoiceAmount" label="开票金额">

                </el-table-column>

            </el-table>
            <table class="remarks-table">
                <tr>
                    <td class="remarks-title">备注信息：{{ remark ? remark : '' }}</td>
                </tr>
            </table>
            <el-button v-if="fileUrl" type="text" @click="down(fileUrl)">下载内容附件</el-button>

        </el-dialog>

    </div>
</template>

<script>
import _request from '@/utils/request.js'
import _tax from '@/service/tax-service'
import examine from '@/views/common/examine'
export default {
    components: {
        examine
    },
    data() {
        return {
            fileUrl: null,
            remark: null,
            title: null,
            titleId: null,
            getCodeModifyData: null,//发票内容明细
            getContentDetailData: null,//修改记录
            dialogVisible: false,
            informationShow: false,
            informationDialogShow: false,
            informationDialogShow2: false,
            informationDialogVisible: false,
            informationId: null,
            informationTemplateId: null,
            info: {
                invoiceApplyCode: null,
                invoiceTitleInfo: {}
            },
            tableData: [],
            query: {
                id: this.$route.query.id
            }
        }
    },
    methods: {
        getDetail() {
            _tax.invoiceApplyGetDetail(
                this.query,
                response => {
                    // 请求成功
                    this.info = response


                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })
        },
        down(fileUrl) {
            location.href = fileUrl
        },
        information(row) {
            this.informationShow = true
            this.informationId = null
            this.informationTemplateId = null
            this.informationId = row.id
            this.informationTemplateId = row.templateId
            this.informationDialogVisible = true
        },
        closeDialog() {
            this.informationShow = false
            this.informationId = null
            this.informationTemplateId = null
        },
        detail(row) {

            if (row.orderType == 3) {
                window.open(_request.getCrmBaseUrl(`/integral-order-detail?orderNo=${row.orderNo}`))
                return
            }

            if (row.orderType == 2) {
                window.open(_request.getCrmBaseUrl(`/recharge-order-detail?id=${row.orderNo}`))
                return
            }
            if (row.orderType == 5) {
                window.open(_request.getCrmBaseUrl(`/purchase-order-detail?orderNo=${row.orderId}`))
                return
            }
            if (row.orderType != 3 && row.storedOrderType == 1){
                window.open(_request.getCrmBaseUrl(`/stored-order-detail?id=${row.orderNo}`))
                return
            }
            if (row.orderType != 3 && row.storedOrderType == 2){
                window.open(_request.getCrmBaseUrl(`/stored-order-custom-detail?id=${row.orderNo}`))
                return
            }
        },
        submitDialog() {
            this.dialogVisible = true
        },
        informationDialogClose() {
            this.getContentDetailData = null
        },
        informationDialogClose2() {
            this.getCodeModifyData = null
        },
        informationDialog(row) {
            this.getContentDetailData = row.oldInvoiceCodeList
            this.informationDialogShow = true
        },
        informationDialog2(row) {
            this.getCodeModifyData = row.contentList
            this.fileUrl = row.fileUrl
            this.remark = row.remark
            this.informationDialogShow2 = true
        },
        submit() {
            _tax.invoiceApplyGetDetailSubmit(this.query, response => {
            this.dialogVisible = false
            this.$router.push({
                path: '/invoice-manage-list'
            })
        }, response => {
            this.$notify({
                message: response,
                type: 'warning'
            })
        })
        },
        goBack () {
         this.$router.back()
      }
    },
    mounted() {
        this.getDetail()
    },



}
</script>

<style scoped>
.tableTyle {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
}

.remarks-table {
    width: 100%;
    height: 48px;
    border: 1px solid #cdd0d6;
    /* border-top: 0px solid #ffff; */
    font-size: 14px;
    color: #606266;
    line-height: 48px;
}

.remarks-title {
    padding-left: 10px;
    font-weight: bold;
}

.remarks-text {
    border-left: 1px solid #cdd0d6;
    padding-left: 10px;
}

.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.content-wapper {
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 30px;
    padding-top: 15px;
    background: #fff;
}

.title {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin: 30px 0 10px 0;
}

.info-wapper li {
    margin: 15px 0;
}

.info-wapper li div {
    display: inline-block;
    width: 400px;
    position: relative;
    word-break: break-word;
}

.info-wapper .special {
    width: 800px;
}

.info-wapper span {
    margin-left: 130px;
    display: inline-block;
    vertical-align: top;
}

.info-wapper label {
    color: #909399;
    display: inline-block;
    width: 100px;
    text-align: right;
    position: absolute;
    top: 0;
}

.textarea {
    display: inline-block;
    width: 500px;
}

.images-wapper {
    border-top: 1px dashed #909399;
    margin-top: 30px;
}

.info-wapper .el-image {
    width: 210px;
    height: 100px;
    border-radius: 6px;
    margin-left: 15px;
}

.table-wapper {
    margin-left: 130px;
    width: 550px;
}

.table-wapper label {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    display: block;
    font-weight: bold;
    border: 1px solid #d6dbe5;
    border-bottom: none;
}

.table-wapper table {
    border: 1px solid #d6dbe5;
    width: 100%;
}

.table-wapper td {
    padding: 10px;
    border-bottom: 1px solid #d6dbe5;
    border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child td {
    font-weight: bold;
    background: #f9f9f9;
}

.table-top {
    width: 100%;
    font-weight: bold;
    border: 1px solid #cdd0d6;
    border-bottom: none;
    height: 50px;
    background: #fff;
    padding-top: 15px;
    padding-left: 10px;
}
</style>